import { DataLayer } from "@grandvisionhq/analytics";
const backInStockEventName = "back_in_stock_notify";
const backInStockSiteFeature = "back_in_stock";
const pushBackInStockButtonClickEvent = (itemType, itemName, itemBrand) => {
  DataLayer.pushEvent({
    event: backInStockEventName,
    site_feature: backInStockSiteFeature,
    interaction_type: "wishlist_click",
    item: {
      type: itemType,
      name: itemName,
      brand: itemBrand
    }
  });
};
const pushBackInStockSubscriptionEvent = ({
  sessionStatus,
  itemType,
  itemName,
  itemBrand,
  message_type
}) => {
  DataLayer.pushEvent({
    event: backInStockEventName,
    site_feature: backInStockSiteFeature,
    interaction_type: "notify_email_confirmation",
    session_status: sessionStatus,
    message_type,
    item: {
      type: itemType,
      name: itemName,
      brand: itemBrand
    }
  });
};
export {
  backInStockEventName,
  backInStockSiteFeature,
  pushBackInStockButtonClickEvent,
  pushBackInStockSubscriptionEvent
};
//# sourceMappingURL=back-in-stock.js.map
